import React from 'react';
import axios from 'axios';
import { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import NeutralButton from './lib/buttons/NeutralButton';
import { Loading } from '../stories/Loading';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '18px',
    height: 'calc(100VH - 120px)',
  },
  buttonContainer: {
    alignSelf: 'stretch',
    justifyItems: 'center',
    padding: '8px',
  },
  loadingContainer: {
    textAlign: 'start',
    height: 'calc(100VH - 120px)',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    width: '100VW',
  },
});

interface PhoneLookupProps {
  phone: string;
  onLookupHandler: (err: any, res: any) => void;
}

const PhoneLookup = ({ phone, onLookupHandler }: PhoneLookupProps) => {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [otherPhone, setOtherPhone] = useState<string | null>(null);

  let handleSubmit: React.FormEventHandler<HTMLFormElement> = (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      axios
        .post('/api/phoneLookup', { phone: otherPhone ? otherPhone : phone })
        .then((res) => res.data)
        .then((res) => {
          onLookupHandler(null, res);
        })
        .catch((err) => {
          console.log(err);
          onLookupHandler(err, {});
        })
        .finally(() => {
          setLoading(false);
        });
    } catch (e) {
      onLookupHandler(e, {});
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className={classes.loadingContainer}>
        <Loading />
      </div>
    );
  } else {
    return (
      <form id="check-in-form" onSubmit={handleSubmit}>
        <div className={classes.container}>
          <div style={{ marginTop: '-120px', marginBottom: '48px' }}>
            <label style={{ padding: '22px' }}>Phone Number *</label>
            <input
              style={{ height: '32px', fontSize: '22px' }}
              name="phone_number"
              id="phone_number"
              pattern="^[1-9]\d{9}"
              inputMode="numeric"
              title="Please enter valid phone number"
              onChange={(e) => setOtherPhone(e.target.value)}
              value={otherPhone || ''}
              required
            />
          </div>
          <div className={classes.buttonContainer}>
            <NeutralButton
              style={{ maxWidth: '300px', width: '100%' }}
              type="submit"
            >
              Go
            </NeutralButton>
          </div>
        </div>
      </form>
    );
  }
};

export default PhoneLookup;
